import { CreateSellerRequest } from '@/features/create-seller-request-form';
import { CabinetWrapper } from '@/shared/cabinet-wrapper';
import { FC } from 'react';

interface Props {
  type?: 'buyer' | 'seller';
}

export const CreateSellerRequestPage: FC<Props> = ({ type = 'seller' }) => {
  return (
    <CabinetWrapper>
      <CreateSellerRequest type={type} />
    </CabinetWrapper>
  );
};
